<template>
   <nav>
        <h3 style="visibility: hidden;">Actions</h3>
        <SelectedFilters />
        <FilterDropdown @toggle="handleFilterToggle"></FilterDropdown>
        <SearchForm></SearchForm>
    </nav>
</template>

<script setup>
import { ref } from 'vue';
import FilterDropdown from '@/components/common/FilterDropdown.vue'
import SearchForm from '@/components/common/Search.vue';
import SelectedFilters from '@/components/common/filters/SelectedFilters.vue';

const filtersOpen = ref(false);

const handleFilterToggle = (isOpen) => {
    filtersOpen.value = isOpen;
};
</script>

<style scoped lang="scss">
nav {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}
</style>
